import React from 'react';

import { getHgproBaseurl } from '../../utils/service';

const ErrorComponent = () => {
  const redirectToHome = () => {
    const baseurl = getHgproBaseurl(window.location.hostname);
    const redirectUrl = `${baseurl}`;
    window.open(redirectUrl, '_self');
  };

  return (
    <div className="text-center w-[65%] pt-16 pb-40 mx-auto md:w-4/5 md:px-4 md:mt-8 md:pt-0 md:pb-8">
      <div>
        <h2 className="font-hg-sans text-2xl leading-[45px] text-center text-gray-90 md:text-xs md:leading-6 md:w-[95%]">
          We could not locate you with the entered information. Please contact{' '}
          <a
            href="mailto:elevatedprofile@healthgrades.com"
            className="text-blue-50 hover:underline"
          >
            elevatedprofile@healthgrades.com
          </a>{' '}
          for further assistance
        </h2>
        <img
          src="/public/images/PaymentFailVector.svg"
          alt="payment fail vector"
          className="mt-5 md:mt-4 mx-auto"
        />
      </div>
      <div className="mt-[60px] pb-8 md:mt-8">
        <button
          type="button"
          className="inline-flex items-center justify-center gap-2.5 rounded-full px-8 py-3 bg-coral-90 text-white hover:bg-red-600 font-hg-sans font-bold cursor-pointer md:w-full"
          onClick={() => redirectToHome()}
        >
          Retry
        </button>
      </div>

      {/* Decorative hexagons */}
      <div className="absolute top-[13%] right-0 md:top-[14%]">
        <img
          src="/public/images/RightOpenHexagon.svg"
          alt="right opened hexagon"
          className="md:h-[70px]"
        />
      </div>

      <div className="absolute -left-[1%] md:left-0 md:bottom-60">
        <img
          src="/public/images/LeftOpenHexagon.svg"
          alt="left opened hexagon"
          className="md:h-[70px]"
        />
      </div>

      <div className="absolute w-[6%] mt-[2%] left-[27%] md:w-[12%] md:bottom-60 md:left-[38%]">
        <img src="/public/images/hexagon_small.svg" alt="hexagon" />
      </div>

      <div className="absolute w-[8%] mt-[8%] left-[22%] md:w-[20%] md:bottom-44 md:left-[22%]">
        <img src="/public/images/hexagon_small.svg" alt="hexagon" />
      </div>
    </div>
  );
};

export default ErrorComponent;
